// MUI import
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

// Local import
import INCOTERMS from '../../utils/Incoterms.js';

function OpportunityIncotermPane(props) {
    const { incoterm, setIncoterm, errors = [], transportationMethod } = props;

    return (
        <FormControl sx={{ width: 'calc(100%)', marginBottom: '18px', marginTop: '18px' }}>
            <InputLabel htmlFor='commerce-terms'>Commerce Terms</InputLabel>
            <Select
                fullWidth
                label={'Commerce Terms'}
                id={`commerce-terms`}
                value={incoterm || 'none'}
                onChange={(event: SelectChangeEvent) => setIncoterm(event.target.value) }
                error={errors.includes('incoterm')}
            >
                {!incoterm && <MenuItem disabled value='none' sx={{ fontSize: '13px' }}>-</MenuItem>}
                <MenuItem disabled sx={{ fontSize: '13px' }}>The seven rules for any mode(s) of transport</MenuItem>
                {INCOTERMS.filter(i => i.group === 1).map(i => (
                    <MenuItem key={i.value} value={i.value}>{i.text}</MenuItem>
                ))}
                {transportationMethod !== 'air' && <MenuItem disabled sx={{ fontSize: '13px' }}>The four rules for Sea and Inland Waterway Transport</MenuItem>}
                {transportationMethod !== 'air' && INCOTERMS.filter(i => i.group === 2).map(i => (
                    <MenuItem key={i.value} value={i.value}>{i.text}</MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default OpportunityIncotermPane;
